import { forwardRef } from 'react';
import { Button } from 'antd';
import MyFlex from '../myFlex/MyFlex';

const MyButton = forwardRef(
  ({ form, label, suffixIcon, ...otherProps }, ref) => {
    return (
      <Button
        ref={ref}
        form={form}
        htmlType={form ? 'submit' : 'button'}
        {...otherProps}
      >
        <MyFlex>
          {Boolean(label) && <span className="bold">{label}</span>}
          {Boolean(suffixIcon) && <div>{suffixIcon}</div>}
        </MyFlex>
      </Button>
    );
  }
);

export default MyButton;
